/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TextField } from '@material-ui/core';
import { element } from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  SubstanceDetailHead,
  SubstanceSummaryHead,
  SubstanceSummaryHead as originalColumnDefs,
} from './TableHead';

import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  viewPortHeight_200,
  viewPortHeight_250,
  viewPortHeight_300,
  viewPortHeight_355,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import { exportPDF } from './ExportPDF';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { getAbuseInfo } from '../Store/action';

const DisplaySubstanceAbuse = () => {
  const gridRef = React.useRef();
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [detail, setDetail] = React.useState([]);
  const [summary, setSummary] = React.useState([]);
  const [previousQuarter, setPreviousQuarter] = React.useState('');
  const [info, setInfo] = React.useState('');
  const [SubstanceSummaryHead, setSubstanceSummaryHead] = React.useState([]);
  const {
    displayObj: {
      rebateProgramName: getRebateProgramName,
      quarterFrom: getQuarter,
      subDetail: getSubDetail,
      subSummary: getSubSummary,
    },
    selectedReport,

    subInfo: getSubInfo,
  } = useSelector((state) => state?.sharedState?.SubstanceReducer);

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  // handling full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  // invoice quarter

  React.useEffect(() => {
    if (getQuarter) {
      const [quarter, year] = getQuarter.split('Q');
      const quarterNumber = parseInt(quarter, 10);
      const prevQuarter = quarterNumber === 1 ? 4 : quarterNumber - 1;
      const prevYear = quarterNumber === 1 ? parseInt(year, 10) - 1 : year;
      const previousQuarterValue = `${prevQuarter}Q${prevYear}`;
      setPreviousQuarter(previousQuarterValue);
    }
  }, [getQuarter]);

  // detail rowData
  React.useEffect(() => {
    let data1 = getSubDetail?.substanceAbuseDrugDetailGridVO;
    data1 = data1?.map((item) => {
      return {
        ...item,
        adjustmentAmt: item.adjustmentAmt ? item.adjustmentAmt : '0.00',
        roaChangeAmt: item.roaChangeAmt ? item.roaChangeAmt : '0.00',
        paymentAmt: item.paymentAmt ? item.paymentAmt : '0.00',

        invoicePmt: item.invoicePmt ? item.invoicePmt : '0.00',
      };
    });
    setDetail(data1);
  }, [getSubDetail]);

  // summary rowdata

  React.useEffect(() => {
    setSummary(getSubSummary?.substanceAbuseDrugSummaryGridVOList);
  }, [getSubSummary]);
  const claims = [
    'Prior Qtr Adjustments',
    'Rebates Invoiced',
    'Payments',
    'Offset Amount',
  ];

  const filteredArray =
    summary?.map((item) => ({
      priorQtrAdjustment: item.priorQtrAdjustment,
      rebateInvoiced: item.rebateInvoiced,
      payments: item.payments,
      offsetAmount: item.offsetAmount,
    })) ?? [];
  const newArray = filteredArray?.map((item) => Object.values(item)) ?? [];
  const col1 = newArray[0] ?? [];
  const col2 = newArray[1] ?? [];
  const col3 = newArray[2] ?? [];
  const col4 = newArray[3] ?? [];
  const col5 = newArray[4] ?? [];

  const rowdata = claims.map((item, index) => {
    return {
      field1: item,
      field2: col1[index],
      field3: col2[index],
      field4: col3[index],
      field5: col4[index],
      field6: col5[index],
    };
  });

  // setting header
  React.useEffect(() => {
    const generateColumnDefs = () => {
      const [quarter, year] = getQuarter?.split('Q');
      const quarterNumber = parseInt(quarter, 10);
      const prevQuarter = quarterNumber === 1 ? 4 : quarterNumber - 1;
      const prevYear = quarterNumber === 1 ? parseInt(year, 10) - 1 : year;
      const headerName1 = `${prevQuarter}Q${prevYear}`;

      const prevQuarterEndDate = new Date(prevYear, prevQuarter * 3, 0);

      const dateRange1 = `${prevQuarterEndDate.toLocaleDateString()}`;

      const prevQuarter2 = prevQuarter === 1 ? 4 : prevQuarter - 1;
      const prevYear2 = prevQuarter === 1 ? prevYear - 1 : prevYear;
      const headerName2 = `${prevQuarter2}Q${prevYear2}`;

      const prevQuarter2EndDate = new Date(prevYear2, prevQuarter2 * 3, 0);
      const dateRange2 = prevQuarter2EndDate.toLocaleDateString();

      const prevQuarter3 = prevQuarter2 === 1 ? 4 : prevQuarter2 - 1;
      const prevYear3 = prevQuarter2 === 1 ? prevYear2 - 1 : prevYear2;
      const headerName3 = `${prevQuarter3}Q${prevYear3}`;

      const prevQuarter3EndDate = new Date(prevYear3, prevQuarter3 * 3, 0);
      const dateRange3 = prevQuarter3EndDate.toLocaleDateString();

      const prevQuarter4 = prevQuarter3 === 1 ? 4 : prevQuarter3 - 1;
      const prevYear4 = prevQuarter3 === 1 ? prevYear3 - 1 : prevYear3;
      const headerName4 = `${prevQuarter4}Q${prevYear4}`;

      const prevQuarter4EndDate = new Date(prevYear4, prevQuarter4 * 3, 0);
      const dateRange4 = prevQuarter4EndDate.toLocaleDateString();

      // Create the modified column definition
      const modifiedColumnDefs = originalColumnDefs.map(
        (SubstanceSummaryHead) => {
          // Modify the header name of the specific column definition
          if (SubstanceSummaryHead.field === 'field2') {
            // Replace 'columnName' with the actual field name in your data
            return {
              ...SubstanceSummaryHead,
              headerName: `Quarter Ending (${dateRange1}) ${headerName1}  `,
            };
          }
          if (SubstanceSummaryHead.field === 'field3') {
            return {
              ...SubstanceSummaryHead,
              headerName: `Quarter Ending (${dateRange2}) ${headerName2} `,
            };
          }
          if (SubstanceSummaryHead.field === 'field4') {
            return {
              ...SubstanceSummaryHead,
              headerName: `Quarter Ending (${dateRange3}) ${headerName3}`,
            };
          }
          if (SubstanceSummaryHead.field === 'field5') {
            return {
              ...SubstanceSummaryHead,
              headerName: `Quarter Ending (${dateRange4}) ${headerName4}`,
            };
          }
          return SubstanceSummaryHead;
        }
      );

      setSubstanceSummaryHead(modifiedColumnDefs);
    };
    generateColumnDefs();
  }, [getQuarter]);
  // substance abuse info
  React.useEffect(() => {
    dispatch(
      getAbuseInfo({
        rpc: getRebateProgramName?.rebateProgramCd,
      })
    );
  }, []);
  React.useEffect(() => {
    setInfo(getSubInfo?.substanceAbuseDrugAgencyInfoVO?.cms64AgencyName);
    const elem = document.getElementsByClassName('customHeaderLabel')[0];

    if (elem && elem.innerText == 'Drug Rebate') {
      elem.style.color = '#274466';
    }
  }, [getSubInfo]);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  // pdf header
  const secondInfo = `Quarter: ${getQuarter}`;
  const thirdInfo = `${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`;

  const customPDFExport = () => {
    const fileName = 'DrugSubstanceAbuseReport-Summmary';

    exportPDF(
      rowdata,
      userDefaults,
      SubstanceSummaryHead,
      getRebateProgramName,
      fileName,
      logInUser,
      dispatch
    );
  };

  return (
    <div className="tabs-contaitBillPanel custom-check tabs-container">
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="State Reports"
        parent2="Display Substance Abuse Drug Report"
      />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="panel custom-fieldset">
              <div className="custom-check">
                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="Rebate_Program"
                        label="Rebate Program"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Rebate_Program' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}
                        disabled
                      />
                    </div>
                  </div>

                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="CMS Report Quarter"
                        id="CMS_QuarterRepo"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'CMS_QuarterRepo' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={getQuarter}
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="Invoice Quarter"
                        id="Invoice_QuarterDisp"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Invoice_QuarterDisp' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={previousQuarter}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {selectedReport == 'Detail' && (
          <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
            <TableGridWithFeatures
              data-testid="Substance-Abuse-onediti"
              rowSelection="single"
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
              rowData={detail}
              columnDefs={SubstanceDetailHead}
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              exportFile
              isScrollOn
              animateRows
              sideBar={false}
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;

                  if (name && name.length > 20) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
              fileName="DrugSubstanceAbuseRpt-Detail"
              reportName="DrugSubstanceAbuseRpt-Detail"
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              info={{ secondInfo, thirdInfo }}
            />
          </div>
        )}
        {selectedReport == 'Summary' && (
          <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
            <TableGridWithFeatures
              data-testid="onEditingStopped"
              rowSelection="single"
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_250}
              rowData={rowdata}
              columnDefs={SubstanceSummaryHead}
              exportFile
              animateRows
              defaultCol={{
                wrapHeaderText: true,
                autoHeaderHeight: true,
              }}
              sideBar={false}
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;

                  if (name && name.length > 20) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name && `${name.substring(0, 20)}...`}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
              fileName="DrugSubstanceAbuseRpt-Summmary"
              reportName="DrugSubstanceAbuseRpt-Summmary"
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              info={{ secondInfo, thirdInfo }}
              customPDFExport={customPDFExport}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DisplaySubstanceAbuse;
